import type { AccountNode, Entry } from '@taler/api-client'

function findAccount(nodes: readonly AccountNode[], accountId: string): AccountNode['account'] | undefined {
  for (const node of nodes) {
    if (node.account.id === accountId) return node.account
    const found = findAccount(node.children, accountId)
    if (found !== undefined) return found
  }
  return undefined
}

/**
 * The minimal shape a schedule's origin entry must have - a transfer with exactly two
 * postings, one of them into an asset account - so the form is never offered on an entry
 * guaranteed to 422. The server stays the authority on everything else; this is not a copy
 * of its validation, only enough to decide whether the section belongs on screen at all.
 */
export function isPrepaidEligibleOrigin(entry: Entry, accounts: readonly AccountNode[]): boolean {
  if (entry.kind !== 'TRANSFER' || entry.postings.length !== 2) return false
  return entry.postings.some((posting) => findAccount(accounts, posting.accountId)?.accountClass === 'ASSET')
}
